import { Model } from '..'
import { PagedCollection } from '..'
import Enhancer from '../Enhancer'
import { BasicCalls } from '@/api/models'

class Order extends Model {
    constructor(json, ...args) {
        super(...args)
        this.apiBase = 'orders'
        this._model = json
        return new Proxy(this, Enhancer)
    }
    get tags() {
        return this._model.tags || []
    }

    cancelOrder() {
        return super.save('cancel')
    }

    resendConfirmation(id) {
        return this.fetch(`${id}/resend_mail`)
    }

    get deliveryJob() {
        return this._model.delivery_job
    }

    set deliveryJob(val) {
        this._model.delivery_job = val
    }

    placeOrder(cart) {
        this.updateModel({
            ...cart,
            ...{ source: process.env.VUE_APP_SOURCE },
        })
        return this.save()
    }

    getOrder(id) {
        return new Promise((resolve, reject) => {
            try {
                this.fetch(id)
                    .then((res) => {
                        this.model = res
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

class PublicOrder extends Order {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'order/shared'
        this._model = json
        return new Proxy(this, Enhancer)
    }
}

class OrderShare extends BasicCalls {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'order'
        this.apiBase = 'share'
    }
    async fetch(_url, _params) {
        return await super.fetch(_url, _params)
    }
}

class Orders extends PagedCollection {
    constructor(...args) {
        super(...args)
        this.apiBase = 'orders'
    }

    push(item) {
        super.push(new Order(item))
    }

    get rate() {
        return this.items.filter((item) => item.order_status === 'approved')
    }

    fetchByRoute(route = {}, params = {}) {
        return this.fetch({
            ...route.query,
            ...route.params,
            ...{
                page: params.page || route.params.page || 1,
                items_per_page: params.per_page || route.params.per_page || 20,
            },
            ...params,
        })
    }
}

export { PublicOrder, Order, Orders, OrderShare }
